import md5 from "md5";
import { getMonthsArray } from "../";

type TariffRow = {
  id: string;
  ts: string;
  [key: string]: string | number;
};

type TariffHourly = {
  ts: string;
  tariff: string | number;
};

type TariffTaxData = {
  meteringPointId?: string | number;
  rabatNettariffHourly: TariffHourly[];
  nettariffHourly: TariffHourly[];
};

type TariffData = {
  tariffDetails?: {
    taxes?: TariffTaxData[];
    month?: number;
  };
};

export const tariffMonthlyRowsCombined = (
  data: TariffData,
  gettext: (key: string) => string,
) => {
  const rows: Record<string, TariffRow[]> = {};

  const taxes = data?.tariffDetails?.taxes;
  const monthsArray = getMonthsArray(gettext);
  const monthIndex = data?.tariffDetails?.month || 0;
  const selectedMonth = monthsArray[monthIndex].value;

  if (Array.isArray(taxes) && taxes.length > 0) {
    taxes.map((objTaxData): null => {
      const orderNo = objTaxData?.meteringPointId;

      if (!rows["all"]) {
        rows["all"] = [];
      }

      if (!rows[selectedMonth]) {
        rows[selectedMonth] = [];
      }

      objTaxData.rabatNettariffHourly.map((rabatNettariffHourly): null => {
        const rowIndex: Record<string, number> = {};
        const id = md5(rabatNettariffHourly.ts);
        rowIndex["all"] = rows["all"].findIndex((obj) => obj.id === id);
        rowIndex[selectedMonth] = rows[selectedMonth].findIndex(
          (obj) => obj.id === id,
        );
        if (rowIndex["all"] > -1) {
          rows["all"][rowIndex["all"]][`rabatNettariff_${orderNo}`] =
            rabatNettariffHourly.tariff;
        } else {
          const row: TariffRow = {
            id: id,
            ts: rabatNettariffHourly.ts,
          };
          row[`rabatNettariff_${orderNo}`] = rabatNettariffHourly.tariff;
          rows["all"].push(row);
        }

        if (rowIndex[selectedMonth] > -1) {
          rows[selectedMonth][rowIndex[selectedMonth]][
            `rabatNettariff_${orderNo}`
          ] = rabatNettariffHourly.tariff;
        } else {
          const row: TariffRow = {
            id: id,
            ts: rabatNettariffHourly.ts,
          };
          row[`rabatNettariff_${orderNo}`] = rabatNettariffHourly.tariff;
          rows[selectedMonth].push(row);
        }
        return null;
      });

      objTaxData.nettariffHourly.map((nettariffHourly): null => {
        const rowIndex: Record<string, number> = {};
        const id = md5(nettariffHourly.ts);
        rowIndex["all"] = rows["all"].findIndex((obj) => obj.id === id);
        rowIndex[selectedMonth] = rows[selectedMonth].findIndex(
          (obj) => obj.id === id,
        );
        if (rowIndex["all"] > -1) {
          rows["all"][rowIndex["all"]][`nettarif_${orderNo}`] =
            nettariffHourly.tariff;
        } else {
          const row: TariffRow = {
            id: id,
            ts: nettariffHourly.ts,
          };
          row[`nettarif_${orderNo}`] = nettariffHourly.tariff;
          rows["all"].push(row);
        }

        if (rowIndex[selectedMonth] > -1) {
          rows[selectedMonth][rowIndex[selectedMonth]][`nettarif_${orderNo}`] =
            nettariffHourly.tariff;
        } else {
          const row: TariffRow = {
            id: id,
            ts: nettariffHourly.ts,
          };
          row[`nettarif_${orderNo}`] = nettariffHourly.tariff;
          rows[selectedMonth].push(row);
        }
        return null;
      });

      return null;
    });
  }
  return rows;
};
